var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdcIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#757575",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.131 4.53c.648-.019 1.192-.257 1.63-.714.44-.457.648-.994.628-1.61-.021-.615-.262-1.142-.722-1.579C8.207.19 7.654-.019 7.006.001c-.648.02-1.192.259-1.63.716-.44.456-.659.993-.659 1.609s.24 1.142.721 1.58c.481.436 1.045.645 1.693.625zM13.23 11.04l-2.838-1.501L8.07 5.936c-.447-.533-.997-.8-1.65-.8-.448 0-.877.183-1.29.55L.687 9.14c-.103.133-.172.283-.206.45l-.464 3.853v.1c0 .233.086.434.258.6.171.167.378.25.619.25.24 0 .438-.083.593-.25.155-.166.25-.35.284-.55l.36-3.303 2.173-1.2-1.135 9.206-2.012 4.354c-.068.2-.103.383-.103.55 0 .367.13.676.387.926.258.25.576.358.955.325.516 0 .894-.234 1.135-.7l2.166-4.704c0-.034.018-.092.052-.175.034-.084.069-.159.103-.225.035-.067.052-.134.052-.2l.258-2.252 2.218 7.405c.24.6.67.884 1.29.851.344 0 .645-.125.903-.375s.386-.56.386-.926c0-.034-.008-.075-.025-.125s-.026-.092-.026-.125L7.813 12.64l.36-3.352.878 1.35c.068.1.154.184.258.25l3.043 1.652c.207.067.344.1.413.1.24 0 .447-.091.62-.275.171-.184.257-.392.257-.625 0-.3-.137-.534-.413-.701z",
    transform: "translate(-12 -135) translate(12 135)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9E9E",
    strokeLinecap: "square",
    d: "M22.025 7.147L8.37 30.113",
    transform: "translate(-12 -135) translate(12 135)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#757575",
    transform: "translate(-12 -135) translate(12 135) translate(17.38 14.897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69 0c.274 0 .497.223.497.498v1.93h-.996V.498c0-.275.223-.498.498-.498zM14.144.187c.275 0 .498.223.498.498v1.93h-.996V.685c0-.275.223-.498.498-.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.412 18.432c.003.433.007.79.013 1.051H3.358v1.21c0 .227-.183.41-.41.41H.775c-.226 0-.41-.183-.41-.41v-1.958c0-.098-.275-.217-.364-.442V16.76c0-.19.617-.375.617-.666V14.42c.391-.776.815-1.351 1.272-1.725V2.589c0-.415.31-.764.72-.814 2.561-.312 4.5-.468 5.819-.468 1.316 0 3.235.156 5.755.467.41.05.719.4.719.813v10.107c.457.374.881.949 1.273 1.725v1.674c0 .291.616.476.616.666v1.534c-.089.225-.364.344-.364.442v1.959c0 .226-.184.41-.41.41h-2.174c-.226 0-.41-.184-.41-.41v-1.211H8.428c-.006-.261-.011-.618-.016-1.051zM5.322 2.988c-.189 0-.342.153-.342.341v.252c0 .188.153.34.342.34h6.09c.188 0 .341-.152.341-.34v-.252c0-.188-.153-.34-.341-.34h-6.09zM3.557 5.603c-.21 0-.386.159-.407.368l-.315 3.103c-.002.013-.002.027-.002.041 0 .226.183.41.41.41H13.69l.042-.003c.225-.022.389-.223.366-.448l-.315-3.103c-.022-.21-.198-.368-.408-.368H3.557zm.395 5.39l-.02.001c-.3.025-.524.289-.5.59l.332 4.04c.012.141.13.25.273.25h8.86c.141 0 .26-.109.271-.25l.332-4.04.001-.02c.014-.302-.22-.557-.52-.571l-4.515-.205-4.514.205zm-2.751 4.321c-.113 0-.205.092-.205.205v.337c0 .113.092.205.205.205h1.184c.113 0 .205-.092.205-.205v-.337c0-.113-.092-.205-.205-.205H1.2zm13.147 0c-.113 0-.204.092-.204.205v.337c0 .113.091.205.204.205h1.185c.113 0 .204-.092.204-.205v-.337c0-.113-.091-.205-.204-.205h-1.185zM.603 16.994c-.113 0-.205.093-.205.206v.71c0 .114.092.205.205.205H16.13c.113 0 .205-.091.205-.204V17.2c0-.113-.092-.205-.205-.205H.603z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.741 6.077h1.398c.15 0 .273.122.273.273v1.99c0 .15-.122.273-.273.273h-.748l-.65.61v-.397l.437-.41V6.38h-.437v-.302z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.398 6.077h1.398c.151 0 .273.122.273.273v1.99c0 .15-.122.273-.273.273H1.05l-.65.61v-.397l.437-.41V6.38H.398v-.302z",
    transform: "matrix(-1 0 0 1 2.468 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.367,
    height: 1,
    x: 4.183,
    y: 11.579,
    rx: 0.205
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.968,
    height: 1,
    x: 4.383,
    y: 12.699,
    rx: 0.205
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.57,
    height: 1,
    x: 4.582,
    y: 13.82,
    rx: 0.205
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.171,
    height: 1,
    x: 4.781,
    y: 14.94,
    rx: 0.205
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "M39 22.072L42.072 19 39 15.944 39.944 15 43.944 19 39.944 23z",
    transform: "translate(-12 -135) translate(12 135)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdcIconGrey);
export default __webpack_public_path__ + "static/media/mdc_icon_grey.38c57b09aa6c30f7013c22ffa7f88c96.svg";
export { ForwardRef as ReactComponent };